import React from 'react';
import { Grid, Breadcrumbs } from 'components/ui';
import { FormattedMessage } from 'react-intl';
import { DashboardLink } from 'utils/link';
import { BreadCrumbLink } from 'components/styles_components/link';

const BreadcrumbContainer = ({ children }) => {
  return (
    <Grid
      sx={{ marginBottom: 2 }}
      direction="row"
      justifyContent="space-between">
      <Breadcrumbs aria-label="breadcrumb" separator="-">
        <BreadCrumbLink to={DashboardLink()}>
          <FormattedMessage id="breadcrumb.home" />
        </BreadCrumbLink>
        {children}
      </Breadcrumbs>
    </Grid>
  );
};

export default BreadcrumbContainer;
